







import TariffZones from "../Tarification/TariffZones.vue";
import { Component, Vue } from "vue-property-decorator";
import { TarificationTypes, TarificationTransports } from "@/store/tarification/types";

@Component({ components: { TariffZones } })
export default class CallOperatorTariffZones extends Vue {
  private operatorType: TarificationTypes = TarificationTypes.OPERATOR;
  private tarificationTransport: TarificationTransports = TarificationTransports.CALL;
}
